import { useQuery } from '@tanstack/react-query';
import { apiJson } from '@lib/apiClient';
import type { SidecarRecord } from '@/types/intake';

export interface ReviewListResponse {
  items: SidecarRecord[];
}

/** Poll the reviewer queue (all intake records for a campaign, newest first). */
export function useReviewQueue(campaign: string) {
  return useQuery({
    queryKey: ['intake-review', campaign],
    queryFn: () => apiJson<ReviewListResponse>(`/api/intake/review/list?campaign=${encodeURIComponent(campaign)}`),
    refetchInterval: 30_000,
    refetchOnMount: 'always', // entering Review pulls the current records immediately
  });
}
